<div *ngIf="loading" class="d-flex justify-content-center">
    <div class="spinner-border text-primary" style="width:100px;height:100px;" role="status"></div>
</div>

<app-splash-screen></app-splash-screen>
<div [hidden]="loading">
    <router-outlet></router-outlet>
</div>
